import {Component, ChangeDetectionStrategy} from "@angular/core";
import {Store} from "@ngrx/store";
import {createTrunkNotice, deleteTrunkNotice, loadTrunkNotices, updateTrunkNotice} from "./+state/trunk-notice.actions";
import {TrunkNotice} from "@knust/api-interfaces";
import {AuthService} from '../../utility/services/auth.service';
import {MatDialog} from "@angular/material/dialog";
import { TrunkNoticeDialogComponent } from './trunk-notice-dialog/trunk-notice-dialog.component';
import {ConfirmComponent} from "../confirm/confirm.component";
import {
  trunkNoticesColumnConfig,
  trunkNoticesCommandMap,
  trunkNoticesDisplayedColumns,
} from './trunk-notices-table-config';

@Component({
    selector: 'knust-trunk-notices',
    templateUrl: './trunk-notices.component.html',
    styleUrls: ['./trunk-notices.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TrunkNoticesComponent {
  commandMap = trunkNoticesCommandMap;
  displayedColumns = trunkNoticesDisplayedColumns;
  columnConfig = trunkNoticesColumnConfig;

  constructor(private store: Store,
              private dialog: MatDialog,
              private authService: AuthService) {
    this.store.dispatch(loadTrunkNotices());
  }

  openTrunkNoticeDialog(trunkNotice?: TrunkNotice) {
    this.dialog.open(TrunkNoticeDialogComponent, {
      data: trunkNotice,
      width: '40vw',
    })
      .afterClosed()
      .subscribe(trunkNotice => {
        if (trunkNotice && !trunkNotice.id) {
          this.store.dispatch(createTrunkNotice( { trunkNotice } ));
        } else if (trunkNotice && trunkNotice.id) {
          this.store.dispatch(updateTrunkNotice( { trunkNotice }));
        }
      });
  }

  deleteTrunkNotice(trunkNotice: TrunkNotice) {
    this.dialog.open(ConfirmComponent, {
      data: {
        title: 'Entnahme-Notiz wirklich löschen?',
        text: 'Möchten Sie diese Entnahme-Notiz wirklich löschen?<br>Alle Entnahmen, die diese Notiz verwenden, behalten diese auch weiterhin bei.',
        buttonColor: 'warn'
      }
    })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.store.dispatch(deleteTrunkNotice({ trunkNotice }));
        }
      })
  }
}
